__turbopack_context__.v({
  "button": "tVY7qW_button",
  "placeholder": "tVY7qW_placeholder",
  "visible": "tVY7qW_visible",
});
